var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-result',{attrs:{"icon":"success","title":"提交成功","subTitle":_vm.subTitle}},[_c('template',{slot:"extra"},[_c('el-button',{attrs:{"size":"medium"},on:{"click":_vm.handleBack}},[_vm._v("返回列表")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":_vm.handleProgress}},[_vm._v("查看进度")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }